<template>
  <div class="banner-wrap">
    <div class="banner">
      <div class="title">推荐资源</div>
      <ul class="list">
        <li v-for="c in bannerList" :key="c.id">
          <router-link :to="{ name: 'ResourceInfo', params: { resId: c.resourceId }}">
            <span>{{ c.title }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// store
import { listBanner } from '@/api/BannerApi'
export default {
  data() {
    return {
      bannerList: []

    }
  },
  created() {
    this.fetchBannerList()
  },

  methods: {
    toResource(resId) {
      const currId = this.$route.params.resId
      if (resId === currId) {
        this.$message.info('已是当前资源')
        return false
      }
      this.$router.push({ name: 'ResourceInfo', params: { resId: resId }})
    },
    fetchBannerList() {
      listBanner()
        .then(resp => {
          this.bannerList = resp.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
// 左侧主题分类
.banner-wrap {
  border: 1px solid #d6d5d5;
  padding: 3px;
  background-color: #fff;
  height: 100%;
  .banner {
    height: 920px;
    width: 100%;
    // background: url(../../../assets/imgs/list-left-bg.png) no-repeat;
    background-color: #fff;
    background-size: 100% 100%;
    padding-top: 20px;
    padding-bottom: 5px;
    // 标题
    .title {
      color: #595959;
      font-size: 20px;
      font-family: 微软雅黑;
      font-weight: bold;
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin: 0px auto;
      background: url(../assets/imgs/list-left-title-bg.png) no-repeat;
    }
    // 分类列表
    .list {
      display: block;
      height: auto;
      list-style: none;
      padding: 5px 10px;
      line-height: 30px;
      padding: 0 40px;
      li {
        color: #595959;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #d6d5d5;
        text-align: left;
        font-weight: normal;
        cursor: pointer;
        padding-left: 0px;
        clear: both;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        a{
          color: #606266;
          text-decoration: none;
        }
        a:hover{
          color: #986c33;
          font-weight: bold;
        }
      }
      li:before {
        content: url(../assets/imgs/list-left-item-icon.png);
        position: relative;
        top: 1px;
        margin-right: 10px;
        float: left;
      }
      li:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
